// frontend\src\pages\Calculators\components\TemperatureTime\TemperatureTime.js
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { FILM_TYPES, DEFAULT_VALUES } from "./constants";

const TemperatureTime = ({ 
  onCalculate, 
  initialBaseTime, 
  initialBaseTemp, 
  initialFilmType 
}) => {
  const [baseTime, setBaseTime] = useState(DEFAULT_VALUES.baseTime.toString());
  const [baseTemp, setBaseTemp] = useState(DEFAULT_VALUES.baseTemp.toString());
  const [targetTemp, setTargetTemp] = useState(DEFAULT_VALUES.targetTemp.toString());
  const [filmType, setFilmType] = useState(FILM_TYPES.BW.value);
  const [isCalculating, setIsCalculating] = useState(false);

  // Принимаем данные из DevChart
  useEffect(() => {
    if (initialBaseTime !== undefined) {
      setBaseTime(initialBaseTime.toString());
    }
    if (initialBaseTemp !== undefined) {
      setBaseTemp(initialBaseTemp.toString());
    }
    if (initialFilmType) {
      setFilmType(initialFilmType);
    }
  }, [initialBaseTime, initialBaseTemp, initialFilmType]);

  const formatTime = (minutes) => {
    const mins = Math.floor(minutes);
    const secs = Math.round((minutes - mins) * 60);
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  const handleCalculate = () => {
    const time = parseFloat(baseTime);
    const base = parseFloat(baseTemp);
    const target = parseFloat(targetTemp);

    if (isNaN(time) || time <= 0) {
      toast.error("Время должно быть положительным числом");
      return;
    }

    if (isNaN(base) || isNaN(target)) {
      toast.error("Температуры должны быть числовыми значениями");
      return;
    }

    setIsCalculating(true);

    setTimeout(() => {
      const q10 = filmType === FILM_TYPES.BW.value 
        ? FILM_TYPES.BW.q10 
        : FILM_TYPES.COLOR.q10;
      const timeRatio = Math.pow(q10, (base - target) / 10);
      const newTime = time * timeRatio;

      onCalculate(
        <div className="text-center py-3">
          <h5 className="mb-3">Время проявки при температуре {target} °C составляет</h5>
          <div className="d-flex justify-content-center align-items-baseline mb-3">
            <span className="display-4 fw-bold text-primary me-2">
              {formatTime(newTime)}
            </span>
          </div>
          <div className="text-muted mb-2">
            Исходное время: <strong>{formatTime(time)}</strong> при <strong>{base}</strong> °C
          </div>
          <div className="text-muted fst-italic">
            Тип плёнки: {filmType === FILM_TYPES.BW.value ? "Чёрно-белая" : "Цветная"}
          </div>
        </div>
      );

      setIsCalculating(false);
    }, 50);
  };

  return (
    <div className="container">
      <h2 className="mb-4">Температурная коррекция времени проявки</h2>
      
      <div className="alert alert-info">
        <strong>Примечание:</strong> Для цветных плёнок точность температуры критически важна!
      </div>
      
      <div className="row g-3 mb-3">
        <div className="col-md-6">
          <label className="form-label">Стандартное время проявки (минуты):</label>
          <input
            type="number"
            className="form-control"
            value={baseTime}
            onChange={(e) => setBaseTime(e.target.value)}
            placeholder={`Например: ${DEFAULT_VALUES.baseTime}`}
            step="0.1"
            min="0.1"
          />
        </div>
        
        <div className="col-md-6">
          <label className="form-label">Тип плёнки:</label>
          <div className="btn-group w-100" role="group">
            {Object.values(FILM_TYPES).map((type) => (
              <button
                key={type.value}
                type="button"
                className={`btn ${filmType === type.value ? "btn-primary" : "btn-outline-primary"}`}
                onClick={() => setFilmType(type.value)}
              >
                {type.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="row g-3 mb-4">
        <div className="col-md-6">
          <label className="form-label">Стандартная температура (°C):</label>
          <input
            type="number"
            className="form-control"
            value={baseTemp}
            onChange={(e) => setBaseTemp(e.target.value)}
            placeholder={`Например: ${DEFAULT_VALUES.baseTemp}`}
            step="0.1"
          />
        </div>

        <div className="col-md-6">
          <label className="form-label">Желаемая температура (°C):</label>
          <input
            type="number"
            className="form-control"
            value={targetTemp}
            onChange={(e) => setTargetTemp(e.target.value)}
            placeholder={`Например: ${DEFAULT_VALUES.targetTemp}`}
            step="0.1"
          />
        </div>
      </div>

      <button
        className="btn btn-primary w-100"
        onClick={handleCalculate}
        disabled={isCalculating}
      >
        {isCalculating ? "Вычисляем..." : "Пересчитать время"}
      </button>
    </div>
  );
};

export default TemperatureTime;